<template>
    <div ref="myElement" class="login-wrapper" 
        :style="{ alignItems: showLocalLogo ? 'center' : 'flex-start' }"
        >
        <div class="pa-0" style="margin: 0 0 -17px 0;" v-if="showLocalLogo">
                <v-col cols="12" sm="12" md="12" class="d-flex justify-center">
                    <img :src="localLogo" style="width: auto;height: 180px;" />
                </v-col>
        </div>
            <!-- Login -->
        <v-card class="login-card">
            <v-card-text style="display: flex;margin: 0; padding: 0 5px;justify-content: center;"
                :style="{
                    alignItems: showLocalLogo ? 'center' : 'flex-start',
                    maxWidth: showLocalLogo ? '85%' : '',
                }">
                    <v-col cols="12">
                        <!-- <v-img align-center justify-center alt="Fusion Logo" class="app img" :src="images.logo" transition="scale-transition" width="200" /> -->
                        <v-alert type="error" v-model="erroralert">{{ errorMessage }}</v-alert>
                        <v-alert type="info" v-model="successalert">{{ successMessage }}</v-alert>
                        <v-form align="left" class="form mt-0">
                            <!-- <div v-if="ProductAdminFlag" class="form-group">
                                <label>{{ $t('_CompanyCode') }}</label>
                                <v-text-field
                                  id="companyCode-field-input-login"
                                  outlined
                                  type="text"
                                  v-model="input.companyCode"
                                  hide-details="true"
                                  placeholder="Enter your company code"
                                />
                              </div> -->
                            <h3 class="mb-1">{{ $t('username') }}</h3>
                            <div class="form-group">
                                <div>
                                    <input id="username-field-input-login" type="text" class="inputFieldCustom"
                                        v-model="input.username" placeholder="Enter your username" />
                                </div>
                                <!-- <v-text-field
                                    id="username-field-input-login"
                                    class="inputFieldCustom"
                                    outlined
                                    name="login"
                                    type="text"
                                    v-model="input.username"
                                    hide-details="true"
                                    placeholder="Enter your username"
                                  /> -->
                            </div>
                            <h3 class="mb-1">{{ $t('password') }}</h3>
                            <div class="form-group" style="align-items: center;">
                                <div>
                                    <input id="password-field-input-login" style="" class="inputFieldCustom"
                                        v-model="input.password" @keyup.enter="login"
                                        :type="show1 ? 'text' : 'password'" placeholder="Enter your password" />
                                    <span style="cursor: pointer; margin-left: -50px; z-index: 1;"
                                        @click="show1 = !show1">
                                        <v-icon size="28">{{ show1 ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                                    </span>
                                </div>
                                <!-- <v-text-field id="password-field-input-login" class="inputFieldCustom" outlined @keyup.enter="login"
                                  v-model="input.password" hide-details="true" placeholder="Enter your password"
                                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'"
                                  @click:append="show1 = !show1" /> -->
                            </div>
                            <v-row class="d-flex justify-end align-center ma-0 mb-7">
                                <!-- <v-checkbox :label="$t('rememberme')" required v-model="rememberMe"></v-checkbox> -->
                                <v-btn class="login " large align="center" justify="center" @click="login"
                                    :loading="loading">
                                    {{ $t('login') }}
                                </v-btn>
                            </v-row>
                            <v-row v-if="SSOMicrosoftFlag" class="d-flex justify-space-between align-center ma-0 mb-7">
                                <v-btn class="loginMicrosoft " large align="center" justify="center"
                                    @click="loginMicrosoft">
                                    <img width="30" :src="microsoftLogo" />&nbsp;
                                    {{ $t('loginMicrosoft') }}
                                </v-btn>
                            </v-row>
                            <v-row v-if="SSOAuthentikFlag" class="d-flex justify-space-between align-center ma-0 mb-7">
                                <v-btn class="loginMicrosoft " large align="center" justify="center"
                                    @click="loginAuthentik">
                                    <img width="30" :src="authentikLogo" />&nbsp;
                                    {{ $t('loginAuthentik') }}
                                </v-btn>
                            </v-row>
                            <v-row v-if="SSOLineFlag" class="d-flex justify-space-between align-center ma-0 mb-4">
                                <v-btn class="loginMicrosoft " large align="center" justify="center" @click="loginLine">
                                    <img width="30" :src="lineLogo" />&nbsp;
                                    {{ $t('loginLine') }}
                                </v-btn>
                            </v-row>
                        </v-form>
                    </v-col>
            </v-card-text>
        </v-card>
        <v-overlay :value="dialog">
            <v-dialog v-model="dialog" persistent width="300">
                <v-card color="#1976D2" dark>
                    <v-card-text class="white--text">
                        Loading Please Wait...
                        <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-overlay>
    </div>
</template>
<script>
import LogTrace from '@/api/function.js';
import Cookies from 'js-cookie';
import i18n from "@/plugins/i18n";
import logoImg from '@/assets/images/chatframework 1.png';
import localLogoImg from '@/assets/chatframework 2 upscale.png';
import bgImg from '@/assets/images/bg-ai.png';

import lineLogoImg from '@/assets/brand/line-icon.png';
import authentikLogoImg from '@/assets/authentik_icon.svg';
import microsoftLogoImg from '@/assets/windows-11.png';

import { useStore } from 'vuex';
export default {
    mixins: [LogTrace],
    name: 'LoginChat',
    setup() {
        const store = useStore();

        return { store };
    },
    data() {
        return {
            localLogo: localLogoImg,
            lineLogo: lineLogoImg,
            microsoftLogo: microsoftLogoImg,
            authentikLogo: authentikLogoImg,
            expiryDate: '',
            rememberMe: false,
            dialog: false,
            loading: false,
            erroralert: false,
            successalert: false,
            successMessage: '',
            errorMessage: '',
            show1: false,
            secretKey: 'SecretPassphrase@2020',
            input: {
                companyCode: '',
                username: '',
                password: '',
            },
            images: {
                logo: logoImg,
                BG: bgImg,
            },
            path: '',
            language: "en",
            SSOMicrosoftFlag: false,
            SSOAuthentikFlag: false,
            SSOLineFlag: false,
            isMobile: false,
            loginWindow: null,
            ProductAdminFlag: false,
            showLocalLogo: false,
            parameterURL: [],
        };
    },
    async created() {
        let self = this;
        await self.checkDevice();
        self.ProductAdminFlag = import.meta.env.VITE_APP_ProductAdmin === 'true'
    },
    mounted: async function () {
        let self = this;
        for (let key in self.$route.query) {
            self.parameterURL[key.toLowerCase()] = self.$route.query[key];
        }
        i18n.locale = self.language;
        await self.clearCookie();
        self.path = self.$route.params.path;
        const rememberMeCookie = Cookies.get('rememberMe');
        if (rememberMeCookie) {
            const userData = JSON.parse(rememberMeCookie);
            self.input.companyCode = userData.companyCode;
            self.input.username = userData.username;
            self.input.password = userData.password;
            self.rememberMe = true;
        }
        if (self.$route.query.full == 'true' || self.$route.query.full == true) {
            this.showLocalLogo = true;
        }
        self.CheckStatusSSO();
    },
    beforeDestroy() {
        // Clean up event listeners
        window.removeEventListener('message', this.handleSSOMessage);
        
        // Close any open popup windows
        if (this.loginWindow && !this.loginWindow.closed) {
            this.loginWindow.close();
        }
    },
    methods: {
        async checkDevice() {
            let self = this;
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            if (/android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                self.isMobile = true;
            } else {
                self.isMobile = false;
            }
        },
        async CheckStatusSSO() {
            let self = this;
            var tempRequest = {
                key: "SSOChat"
            }
            self.$call.CheckStatusSSO(
                tempRequest,
                (dataResponse) => {
                    if (dataResponse.status == 0) {
                        self.SSOAuthentikFlag = dataResponse.data.authentik;
                        self.SSOMicrosoftFlag = dataResponse.data.microsoft;
                        self.SSOLineFlag = dataResponse.data.line;
                        // self.ProductAdminFlag = await utils.decryptCipherText(dataResponse.data.productAdminFlag, import.meta.env.VITE_APP_EncryptLogKey, import.meta.env.VITE_APP_EncryptLogIV);
                    }
                },
                (errorResource) => {
                    console.error(errorResource);
                }
            );
        },
        async loginMicrosoft() {
            let self = this;
            self.clearMessage();
            console.log('loginMicrosoft');

            let domain = self.parameterURL.domainname;
            if (self.isMobile) {
                self.loginWindow = window.open(`${import.meta.env.VITE_APP_API}api/v0/SSO/SignInChat?domain=${domain}`, '_blank', 'width=600,height=400');

                // Remove any existing event listeners to prevent conflicts
                window.removeEventListener('message', self.handleSSOMessage);
                
                // Add new event listener
                window.addEventListener('message', self.handleSSOMessage);
            }
            else {
                window.open(`${import.meta.env.VITE_APP_API}api/v0/SSO/SignInChat?domain=${domain}`, "Popup", "width=850,height=750");

                // Remove any existing event listeners to prevent conflicts
                window.removeEventListener('message', self.handleSSOMessage);
                
                // Add new event listener
                window.addEventListener('message', self.handleSSOMessage);
            }
        },
        async loginAuthentik() {
            let self = this;
            self.clearMessage();
            console.log('loginAuthentik');

            let domain = self.parameterURL.domainname;

            if (self.isMobile) {
                self.loginWindow = window.open(`${import.meta.env.VITE_APP_API}api/v0/SSO/SignInChatAuthentik?domain=${domain}`, '_blank', 'width=600,height=400');

                // Remove any existing event listeners to prevent conflicts
                window.removeEventListener('message', self.handleSSOMessage);
                
                // Add new event listener
                window.addEventListener('message', self.handleSSOMessage);
            }
            else {
                window.open(`${import.meta.env.VITE_APP_API}api/v0/SSO/SignInChatAuthentik?domain=${domain}`, "Popup", "width=850,height=750");

                // Remove any existing event listeners to prevent conflicts
                window.removeEventListener('message', self.handleSSOMessage);
                
                // Add new event listener
                window.addEventListener('message', self.handleSSOMessage);
            }
        },
        async loginLine() {
            let self = this;
            self.clearMessage();
            let domain = self.parameterURL.domainname;
            const ssoUrl = `${import.meta.env.VITE_APP_API}api/v0/SSO/SignInChatLine?domain=${domain}`;

            if (self.isMobile) {
                self.loginWindow = window.open(ssoUrl, "_blank", "width=850,height=750");
            } else {
                window.open(ssoUrl, "Popup", "width=850,height=750");
            }

            // Remove any existing event listeners to prevent conflicts
            window.removeEventListener('message', self.handleSSOMessage);
            
            // Add new event listener
            window.addEventListener('message', self.handleSSOMessage);
        },
        async RedirectToChat() {
            let self = this;
            this.store.commit('setSnippetStatus', true);
            if (self.path == 'FullStream' || self.$route.query.full == 'true' || self.$route.query.full == true) {
                self.$router.push({
                    name: 'FullStream',
                    params: { path: self.path },
                    query: self.$route.query
                })
            }
            else {
                self.$router.push({
                    name: 'Snippet',
                    params: { path: self.path },
                    query: self.$route.query
                })
            }
        },
        async handleSSOMessage(event) {
            let self = this;
            try {
                const data = event.data;
                
                // Validate that we have the expected data structure
                if (!data || !data.sessionToken) {
                    console.log('Received invalid or incomplete SSO data:', data);
                    return;
                }

                console.log('Received SSO data:', data);
                
                // Set session storage
                sessionStorage.setItem('token_Snippet', data.sessionToken);
                sessionStorage.setItem('username_Snippet', data.sessionUsername);
                sessionStorage.setItem('email_Snippet', data.sessionEmail);
                sessionStorage.setItem('isSnippet', true);

                // Set cookies
                Cookies.set('token_Snippet', data.sessionToken);
                Cookies.set('username_Snippet', data.sessionUsername);
                Cookies.set('email_Snippet', data.sessionEmail);
                Cookies.set('isSnippet', true);

                // Close the popup window if it exists
                if (self.loginWindow && !self.loginWindow.closed) {
                    self.loginWindow.close();
                }

                // Remove the event listener to prevent multiple calls
                window.removeEventListener('message', self.handleSSOMessage);

                // Add a small delay to ensure session storage is set
                setTimeout(async () => {
                    await self.RedirectToChat();
                }, 100);
                
            } catch (error) {
                console.error("Error processing SSO message:", error);
                self.errorMessage = 'Login failed. Please try again.';
                self.erroralert = true;
                
                // Remove the event listener even on error
                window.removeEventListener('message', self.handleSSOMessage);
            }
        },
        async clearCookie() {
            Object.keys(Cookies.get()).forEach(function (cookieName) {
                if (cookieName != 'rememberMe') {
                    Cookies.remove(cookieName);
                }
            });
            sessionStorage.clear();
        },


        login: async function () {
            let self = this;
            self.clearMessage();
            self.loading = true;
            let companyCode = self.input.companyCode?.toLowerCase();
            let userName = self.input.username?.toLowerCase();
            let password = self.input.password;
            await self.$call.ChatLogin(
                {
                    CompanyCode: companyCode,
                    UserName: userName,
                    Password: password,
                },
                async (dataResponse) => {
                    if (dataResponse.status == 0) {
                        await self.RedirectToChat();
                        console.log(dataResponse.data);
                        sessionStorage.setItem('token_Snippet', dataResponse.data.token);
                        sessionStorage.setItem('username_Snippet', dataResponse.data.username);
                        sessionStorage.setItem('email_Snippet', dataResponse.data.email);
                        sessionStorage.setItem('isSnippet', true);
                        
                        Cookies.set('token_Snippet', dataResponse.data.token);
                        Cookies.set('username_Snippet', dataResponse.data.username);
                        Cookies.set('email_Snippet', dataResponse.data.email);
                        Cookies.set('isSnippet', true);

                        // if (this.rememberMe) {
                        //     Cookies.set(
                        //         'rememberMe',
                        //         JSON.stringify({
                        //             companyCode: companyCode,
                        //             username: userName,
                        //             password: password,
                        //         }),
                        //         { expires: 365 }
                        //     );
                        // } else {
                        //     Cookies.remove('rememberMe');
                        // }
                        await self.$swal.fire({
                            icon: 'success',
                            title: dataResponse.message,
                            showConfirmButton: false,
                            timer: 2000,
                        });
                        // window.close();
                        await self.RedirectToChat();
                        self.$root.LeftNavBar = true;
                    }
                    else {
                        await self.$swal.fire({
                            icon: 'error',
                            title: dataResponse.message,
                            showConfirmButton: false,
                            timer: 2000,
                        });
                    }
                    self.dialog = false;
                    self.loading = false;
                },
                (errorResource) => {
                    self.erroralert = true;
                    // self.errorMessage = errorResource;
                    self.errorMessage = 'The User was not found.';
                    self.loading = false;
                }
            );
        },
        clearMessage: function () {
            this.erroralert = false;
            this.successalert = false;
            this.errorMessage = '';
            this.successMessage = '';
        },
        readCookie(name) {
            let nameEQ = name + '=';
            let ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        },
        cryptoMethods(type, value) {
            let self = this;
            if (value != null || value != '' || value != undefined) {
                if (type == 'encrypt') {
                    const encryptedText = this.CryptoJS.AES.encrypt(value, self.secretKey).toString();
                    return encryptedText;
                } else {
                    const decryptedText = this.CryptoJS.AES.decrypt(value, self.secretKey).toString(this.CryptoJS.enc.Utf8);
                    return decryptedText;
                }
            }
        },
    },
};
</script>
<style scoped>
.inputFieldCustom {
    box-shadow: 3px 4px 5px rgba(0, 0, 0, 0.15);
    height: 60px;
    border-radius: 12px !important;
    border: none;
    background: rgb(248, 248, 248);
    outline: 0;
    padding: 0 16px; /* Add horizontal padding */
    border: 0px solid #ccc !important;
    transition: box-shadow 0.3s ease;
    font-size: 16px; /* Prevent zoom on iOS */
    width: 100%;
    box-sizing: border-box;
}

.inputFieldCustom:focus {
    box-shadow: 8px 8px 10px rgba(0, 0, 0, 0.15);
}

.inputFieldCustom::placeholder {
    color: #afafafb6;
}

.loginMicrosoft {
    width: 100% !important;
    min-height: 50px !important;
    height: auto !important;
    border-radius: 10px !important;
    background: #f3f2f5 !important;
    color: rgba(0, 0, 0, 0.74);
    border: 0px solid rgba(0, 0, 0, 0.555);
    box-shadow: 7px 9px 12px rgba(39, 47, 63, 0.2), -7px -9px 12px rgba(255, 255, 255, 1) !important;
    padding: 12px 16px !important;
    white-space: normal !important;
    word-wrap: break-word !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center !important;
    line-height: 1.2 !important;
}

.login {
    width: 150px;
    min-width: 120px;
    border-radius: 60.026px !important;
    background: #ff4768 !important;
    color: #fff;
    box-shadow: 3px 3px 5px rgba(204, 113, 113, 0.7) !important;
    transition: box-shadow 0.3s ease;
    height: auto !important;
    min-height: 50px !important;
    padding: 12px 16px !important;
}

.login:hover {
    box-shadow: 4px 4px 8px rgb(224, 118, 118) !important;
    /* background: #ff5d7a !important; */
}

.form {
    min-width: 50%;
    width: 100%;
}

.img-intersection {
    width: 100%;
    height: 100%;
    max-width: 100%;
}

.img-intersection2 {
    width: 100%;
    height: 77vh;
    max-width: 100%;
}

.BGRedToBlue {
    background: url("@/assets/images/Rectangle 51.png") !important;
    /* background: linear-gradient(to right, rgb(219, 11, 171), blue); */
    color: white;
}

::v-deep .v-input__control .v-input__slot .v-text-field__slot input {
    font-size: 16px !important;
}

.form-group {
    margin: 0 0 15px 0 !important;
    padding: 0 !important;
    text-align: left;
    width: 100%;
}

.form-group label {
    display: block;
    font-size: 14px;
    color: #666;
}

.form-group input {
    width: 100%;
    padding: 16px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 16px;
    box-sizing: border-box;
}

.form-group input:focus {
    border-color: #007bff;
    outline: none;
}

.form-group div {
    position: relative;
    width: 100%;
}

.login-wrapper {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 9999;
  width: 100vw;
  max-width: 100vw;
  height: 100vh;
  max-height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background: #f1f0f6;
  overflow: auto;
  padding: 12px 0;
  flex-direction: column;
  top: 0; left: 0; right: 0; bottom: 0;
  gap: 16px;
}

.login-card {
  width: 100%;
  max-width: 400px;
  border-radius: 25px;
  box-shadow: 9px 12px 16px rgba(126, 126, 126, 0.2), -9px -12px 16px rgba(255, 255, 255, 1) !important;
  background: #f1f0f6;
  display: flex;
  justify-content: center;
  padding: 25px;
  overflow-y: auto;
}


.login-wrapper .login-card {
  max-width: 600px;
  width: 100%;
  min-height: unset;
  margin: 0 auto;
  box-shadow: 0 12px 32px rgba(0,0,0,0.18);
}

/* Enhanced Mobile Styles */
@media (max-width: 768px) {
  .login-wrapper {
    padding: 8px !important;
    gap: 12px;
  }
  
  .login-card {
    max-width: 100% !important;
    padding: 20px !important;
    border-radius: 20px !important;
  }
  
  .form {
    min-width: 100% !important;
  }
  
  .inputFieldCustom {
    height: 50px;
    font-size: 16px;
    padding: 0 12px;
  }
  
  .loginMicrosoft {
    min-height: 48px !important;
    padding: 8px 12px !important;
    font-size: 14px !important;
  }
  
  .loginMicrosoft img {
    width: 24px !important;
    margin-right: 8px !important;
  }
  
  .login {
    width: 120px;
    min-height: 48px !important;
    padding: 8px 12px !important;
    font-size: 14px !important;
  }
  
  h3 {
    font-size: 16px !important;
  }
}

@media (max-width: 600px) {
  .login-wrapper{
    width: 100vw !important;
    max-width: 100vw !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    top: 0 !important;
    border-radius: 0 !important;
    padding: 8px !important;
  }
  
  .login-card {
    max-width: 100vw !important;
    border-radius: 0 !important;
    padding: 16px !important;
  }
  
  .inputFieldCustom {
    height: 48px;
    padding: 0 12px;
  }
  
  .loginMicrosoft {
    min-height: 44px !important;
    padding: 6px 8px !important;
    font-size: 13px !important;
  }
  
  .loginMicrosoft img {
    width: 20px !important;
  }
  
  .login {
    width: 100px;
    min-height: 44px !important;
    padding: 6px 8px !important;
    font-size: 13px !important;
  }
  
  .form-group {
    margin: 0 0 12px 0 !important;
  }
  
  h3 {
    font-size: 14px !important;
    margin-bottom: 8px !important;
  }
  
  /* Better spacing for password field with eye icon */
  .form-group div {
    display: flex;
    align-items: center;
  }
  
  .form-group span {
    margin-left: -40px !important;
    padding: 8px;
  }
}

@media (max-width: 480px) {
  .login-wrapper {
    padding: 4px !important;
  }
  
  .login-card {
    padding: 12px !important;
  }
  
  .inputFieldCustom {
    height: 44px;
    font-size: 14px;
    padding: 0 10px;
  }
  
  .loginMicrosoft {
    min-height: 40px !important;
    padding: 4px 6px !important;
    font-size: 12px !important;
  }
  
  .login {
    width: 90px;
    min-height: 40px !important;
    font-size: 12px !important;
  }
  
  h3 {
    font-size: 13px !important;
  }
  
  .form-group span {
    margin-left: -35px !important;
  }
  
  /* Adjust v-icon size for very small screens */
  .form-group span .v-icon {
    font-size: 20px !important;
  }
}

/* Landscape orientation adjustments */
@media (max-height: 500px) and (orientation: landscape) {
  .login-wrapper {
    align-items: center !important;
    padding: 4px !important;
  }
  
  .login-card {
    max-height: 90vh;
    overflow-y: auto;
  }
  
  .inputFieldCustom {
    height: 40px;
  }
  
  .loginMicrosoft {
    min-height: 36px !important;
  }
  
  .login {
    min-height: 36px !important;
  }
}

@media (max-width: 600px) {
  .login-wrapper{
    width: 100vw !important;
    max-width: 100vw !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    top: 0 !important;
    border-radius: 0 !important;
    padding-top: 0 !important;
  }
  .login-card {
    max-width: 100vw !important;
    border-radius: 0 !important;
  }
}
</style>
